import { render, staticRenderFns } from "./TreeRelation.vue?vue&type=template&id=5fd9e49a&"
import script from "./TreeRelation.vue?vue&type=script&lang=js&"
export * from "./TreeRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd9e49a')) {
      api.createRecord('5fd9e49a', component.options)
    } else {
      api.reload('5fd9e49a', component.options)
    }
    module.hot.accept("./TreeRelation.vue?vue&type=template&id=5fd9e49a&", function () {
      api.rerender('5fd9e49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/TreeRelation.vue"
export default component.exports